import { render, staticRenderFns } from "./InputCounter.vue?vue&type=template&id=06832b04&scoped=true"
import script from "./InputCounter.vue?vue&type=script&lang=js"
export * from "./InputCounter.vue?vue&type=script&lang=js"
import style0 from "./InputCounter.vue?vue&type=style&index=0&id=06832b04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06832b04",
  null
  
)

export default component.exports